<template>
    <div id="container">
        <div id="header">
            <div>
                <i :class="`${icon} mr-2`" />
                <span>{{ module }}</span>
            </div>
            <div id="collapse_toggle" @click="toggleCollapse">
                <i v-if="visible" class="fas fa-eye-slash" />
                <i v-else class="fas fa-eye" />
            </div>
        </div>
        <b-collapse id="collapse" v-model="visible">
            <slot></slot>
        </b-collapse>
    </div>
</template>
<script>
export default {
    props: {
        module: String,
        icon: String,
    },
    data: () => ({ visible: true }),
    methods: {
        toggleCollapse() {
            this.visible = !this.visible
        },
    },
}
</script>
<style lang="scss" scoped>
#container {
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid #c8ced3;
    border-radius: 0.25rem;

    #header {
        display: flex;
        color: #6e6e6e;
        padding: 5px 10px 5px 10px;
        justify-content: space-between;
        border-bottom: 1px solid #c8ced3;
        background: #ebebeb;

        #collapse_toggle {
            cursor: pointer;
        }
    }

    #collapse {
        padding: 5px;
    }
}
</style>
